import React, { Component } from "react";
import { withStyles } from "material-ui";
import Paper from "material-ui/Paper";
import classNames from "classnames";

const styles = theme => ({
  container: {
    flex: "1 1 0%",
    minWidth: 0,
    width: "auto",
    boxSizing: "border-box",
    backgroundColor: theme.palette.background.default,
    padding: "70px 16px 15px 16px",
    overflow: "hidden"
  },

  containerFullWidth: {
    width: "100%",
    maxWidth: "100%"
  },

  paper: {
    width: "100%",
    maxWidth: "100%",
    height: "calc(100vh - 80px)",
    overflowX: "auto",
    overflowY: "auto",
    borderRadius: "0px",
    boxSizing: "border-box"
  },

  fullWidthContainer: {
    width: "100%",
    maxWidth: "100%"
  }
});

class MainContainer extends Component {
  render() {
    const {
      classes,
      children,
      shouldRenderMobileMenu
    } = this.props;

    const containerClass = shouldRenderMobileMenu
      ? classNames(classes.paper, classes.fullWidthContainer)
      : classes.paper;

    const mainClass = shouldRenderMobileMenu
      ? classNames(classes.container, classes.containerFullWidth)
      : classes.container;

    return (
      <main className={mainClass}>
        <Paper className={containerClass} elevation={4}>
          {children}
        </Paper>
      </main>
    );
  }
}

export default withStyles(styles, { withTheme: true })(MainContainer);
